/**
 * Plans — libellés français centralisés.
 * Les `code` (essential/business/scale/enterprise/cabinet) sont des IDs
 * techniques stables côté backend, JAMAIS traduits. Seuls les LABELS
 * (affichage utilisateur) sont en français.
 */

export const PLAN_LABELS = {
  essential: "Essentiel",
  business: "Pro",
  scale: "Croissance",
  enterprise: "Grande entreprise",
  cabinet: "Cabinet",
};

/** Retourne le libellé français d'un plan_code, avec fallback sur le code. */
export const planLabel = (code) => {
  if (!code) return "—";
  return PLAN_LABELS[String(code).toLowerCase()] || code;
};

export default { PLAN_LABELS, planLabel };
